import React from 'react';

export const UserHubsIncompleteContactImage = (props) => {
  const { className = '', style = {}, text = 'Incomplete' } = props;
  return (
    <svg
      className={className}
      style={style}
      width="79"
      height="67"
      viewBox="0 0 79 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.5 2.64078C54.6139 2.64078 66.8592 14.8861 66.8592 30C66.8592 45.1139 54.6139 57.3592 39.5 57.3592C24.3861 57.3592 12.1408 45.1139 12.1408 30C12.1408 14.8861 24.3861 2.64078 39.5 2.64078ZM39.5 0.5C23.23 0.5 10 13.73 10 30C10 46.27 23.23 59.5 39.5 59.5C55.77 59.5 69 46.27 69 30C69 13.73 55.77 0.5 39.5 0.5Z"
        fill="#808080"
      />
      <path
        d="M39.5 2.64078C54.6139 2.64078 66.8592 14.8861 66.8592 30C66.8592 45.1139 54.6139 57.3592 39.5 57.3592C24.3861 57.3592 12.1408 45.1139 12.1408 30C12.1408 14.8861 24.3861 2.64078 39.5 2.64078ZM39.5 0.5C23.23 0.5 10 13.73 10 30C10 46.27 23.23 59.5 39.5 59.5C55.77 59.5 69 46.27 69 30C69 13.73 55.77 0.5 39.5 0.5Z"
        fill="#F9C030"
      />
      <circle cx="39.5" cy="30" r="27.5" fill="white" />
      <path
        d="M39.5 28.7157C42.0261 28.7157 44.1669 27.8166 45.9651 26.0183C47.7634 24.2201 48.6625 22.0793 48.6625 19.5532C48.6625 17.0271 47.7634 14.8863 45.9651 13.088C44.1669 11.2898 42.0261 10.3906 39.5 10.3906C36.9738 10.3906 34.833 11.2898 33.0348 13.088C31.2365 14.8863 30.3374 17.0271 30.3374 19.5532C30.3374 22.0793 31.2365 24.2201 33.0348 26.0183C34.833 27.8166 36.9738 28.7157 39.5 28.7157Z"
        fill="#808080"
      />
      <path
        d="M52.73 36.765C49.3904 34.7527 44.9804 33.7251 39.5 33.7251C34.0196 33.7251 29.6096 34.7527 26.2699 36.765C22.9303 38.7773 21.2605 41.5175 21.2605 44.9428V47.212C21.2605 47.212 21.3889 47.3833 21.4746 47.4689C26.0987 52.093 32.4782 54.9617 39.5428 54.9617C46.6074 54.9617 52.9869 52.093 57.611 47.4689C57.6538 47.4261 57.7395 47.3405 57.7823 47.2977V44.9856C57.7823 41.5604 56.1125 38.863 52.7728 36.8078L52.73 36.765Z"
        fill="#808080"
      />
      <rect x="0.5" y="48" width="78" height="19" rx="9.5" fill="#F9C030" />
      <text
        x="39.5"
        y="61.5"
        textAnchor="middle"
        fontSize="12"
        fontWeight="bold"
        fill="#0A0A0A"
        fontFamily="Euclid Circular A"
      >
        {text}
      </text>
    </svg>
  );
};
